import { createSelector } from '@reduxjs/toolkit';

export const selectModalsVisibility = (state) => state.modals.visibility;
export const selectModalsData = (state) => state.modals.data;

export const selectModalVisibleByKey = (key) =>
  createSelector([selectModalsVisibility], (visibility) => visibility[key]);

export const selectModalDataByKey = (key) =>
  createSelector([selectModalsData], (data) => data[key]);
